module.exports = __webpack_public_path__ + "static/media/LowConga808.a9a68790.wav";